angular.module('invoice')
    .component('invoiceAccessGroupPickerMultiple', {
        require: {
            ngModelCtrl: "^ngModel"
        },
        bindings: {
            ngModel: '=',
            required: "=",
            modelType: '<?',
            onChange: "&",
            entityId: '<?',
            activeOnly: '<?',
            includeAll: '<?',
        },
        templateUrl: "app/invoice/access-group/picker-multiple.html",
        controllerAs: 'ctrl',
        controller: function ($scope, $element, $attrs, InvoiceAccessGroup, uiSelectFix) {
            let ctrl = this
            ctrl.uiSelectFix = uiSelectFix

            ctrl.$onInit = () => {
                ctrl.executeOnChange = ctrl.onChange || angular.noop
                ctrl.modelTypeR = ctrl.modelType || "object"
                const params = {entityId: this.entityId}
                if (ctrl.activeOnly === true) {
                    params.activeOnly = true
                }
                if (ctrl.includeAll === true) {
                    params.all = true
                }
                InvoiceAccessGroup.autocomplete(params).$promise.then(items => ctrl.items = formatAndMap(items))
            }

            ctrl.$onChanges = () => { //changes from parent controller
                ctrl.selected = formatAndMap(ctrl.ngModel)
                ctrl.ngChange()
            }
            ctrl.ngChange = () => ctrl.ngModel = ctrl.selected

            function formatAndMap (items){
                if(!angular.isArray(items)){
                    return []
                }
                return items
                    .map(item => ({id: item.id, name: item.name, active: item.active}))
                    .sort((a, b) => a.name > b.name ? 1 : -1)
            }
        },
    })
